<template>
  
</template>

<script>
export default {
  name: 'comp-check-query',
  computed: {
    isIdTokenExpired: function () {
      return this.$store.getters.isIdTokenExpired
    }
  },
  data: function () {
    return {
      checkingQuery$i: null
    }
  },
  watch: {
    isIdTokenExpired: function () {
      this.onChangeIsIdTokenExpired()
    }
  },
  mounted: function () {
    this.startCheckingQuery()
  },
  beforeDestroy: function () {
    this.stopCheckingQuery()
  },
  methods: {
    startCheckingQuery: function () {
      this.stopCheckingQuery()
      this.checkQuery()
      // TODO - this is commented out for testing... need to be uncommented.
      let checkingInterval = 1000 * 1
      this.checkingQuery$i = setInterval(() => {
        if ((this.$route.path + '').indexOf('token') === -1) {
          this.checkQuery()
        }
      }, checkingInterval)
    },
    stopCheckingQuery: function () {
      if (this.checkingQuery$i) {
        clearInterval(this.checkingQuery$i)
      }
    },
    checkQuery: function () {
      if (this.$token.hasValidToken()) {
        // this.$logger.info('Valid token: ' + this.$token.idToken)
      } else {
        // TODO - this is commented out for testing... need to be uncommented.
        this.goToTokenInvalidPage()
        this.$logger.warn('Invalid token: ' + this.$token.idToken)
      }
      this.updateIdToken(this.$token.idToken)
    },
    updateIdToken: function (idToken) {
      this.$store.commit('UPDATE_IDTOKEN', {
        idToken: idToken
      })
    },
    onChangeIsIdTokenExpired: function () {
      if (this.isIdTokenExpired) {
        // TODO - this is commented out for testing... need to be uncommented.
        this.goToTokenExpiredPage()
        this.$logger.warn('idToken is expired!')
      }
    },
    goToTokenInvalidPage: function () {
      this.$router.push({name: 'TokenInvalid', query: this.$route.query})
    },
    goToTokenExpiredPage: function () {
      this.$router.push({name: 'TokenExpired', query: this.$route.query})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CompCheckQuery.vue